import { createStructuredSelector } from 'reselect';
import { areImagesBeingDownloaded } from 'containers/App/selectors';
import { countryAbbreviations } from 'containers/CountryAbbreviations/selectors';
import { areReusableLayoutsBeingUploaded, exportForTranslationsEnabled } from 'containers/Documents/selectors';
import {
  activeLayer,
  activeSurfaceId,
  isOpenToolbar,
  isProjectTranslatable,
  isUploadAvailable,
  lastLocalSaveTime,
  originalCountry,
  originalLanguage,
} from 'containers/Project/selectors';
import { isRedoDisabled, isUndoDisabled } from 'containers/UndoRedoControl/selectors';

export const headerUndoRedoSelector = createStructuredSelector({
  isRedoDisabled,
  isUndoDisabled,
});

export const headerSelector = createStructuredSelector({
  activeLayer,
  activeSurfaceId,
  areImagesBeingDownloaded,
  areReusableLayoutsBeingUploaded,
  countryAbbreviations,
  exportForTranslationsEnabled,
  isOpenToolbar,
  isTranslationAvailable: isProjectTranslatable,
  isUploadAvailable,
  lastLocalSaveTime,
  originalCountry,
  originalLanguage,
});
